import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ThirdPartyJobPaymentsService from '../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import VoidedThirdPartyJobPaymentsAdminSearchParams from './VoidedThirdPartyJobPaymentsAdminSearchParams';
import VoidedThirdPartyJobPaymentsAdminItem from '../../../../Domain/ThirdParty/ThirdPartyJobPayments/VoidedThirdPartyJobPaymentsAdminItem';
import ApproveWindowDescription from './Actions/ApproveWindowDescription';
import VoidAndSupressWindowDescription from './Actions/VoidAndSupressWindowDescription';
import VoidAndReissueWindowDescription from './Actions/VoidAndReissueWindowDescription';
import VoidWindowDescription from './Actions/VoidWindowDescription';
import EvaluatorPaymentActionParamsItem from '../../../Evaluator/EvaluatorAdmin/EvaluatorPayments/EvaluatorPaymentActionParamsItem';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import ThirdPartyJobPaymentsItem from '../../../../Domain/ThirdParty/ThirdPartyJobPayments/ThirdPartyJobPaymentsItem';

export default class VoidedThirdPartyJobPaymentsAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchItem: new VoidedThirdPartyJobPaymentsAdminSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      allItemsInTheSearchSetAreSelected: false,
      popup: null,
    };

    this.startSearch = this.startSearch.bind(this);
    ThirdPartyJobPaymentsItem.actionFunction = this.clickOnAction.bind(this);
  }

  clickOnAction(paymentIds, actionType) {
    let windowDescription = null;
    switch (actionType) {
      case 'Void':
        windowDescription = VoidWindowDescription;
        break;
      case 'VoidAndReissue':
        windowDescription = VoidAndReissueWindowDescription;
        break;
      case 'VoidAndSupress':
        windowDescription = VoidAndSupressWindowDescription;
        break;
      default:
        windowDescription = ApproveWindowDescription;
    }

    const paramsData = new EvaluatorPaymentActionParamsItem(
      paymentIds,
      this.state.allItemsInTheSearchSetAreSelected,
      this.state.searchItem
    );

    this.setState({
      popup: (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={paramsData}
          clickOnCancel={() => this.setState({ popup: null })}
          clickOnSave={() => this.setState({ popup: null })}
          windowDescription={windowDescription}
        />
      ),
    });
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.popup}
        <TabOfDataTable
          type={VoidedThirdPartyJobPaymentsAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ThirdPartyJobPaymentsService.GetTpEvaluatorTpJobPayments}
          convertDBItemsFunction={ThirdPartyJobPaymentsService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy='AsEvname'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          showSearchStrip={true}
          searchParamsType={VoidedThirdPartyJobPaymentsAdminSearchParams}
          enableUrlPush={false}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Evaluators or Pay IDs...'
        />
      </div>
    );
  }
}
